module.exports = __webpack_public_path__ + "static/mechanic-495e3a34d5efc9505138acc429b51a40.png";